import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Section } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Add course section
 * @param course_id
 * @param version
 * @param section
 */
const addCourseSection = (
  course_id: string,
  version: number,
  section: {
    title: string
    description: string
  }
): Promise<Section> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/sections'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.post(URL, section, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default addCourseSection
